<template>
<div class="doc-blocks">
  <template v-for="(block, index) in blocks">
    <h2 v-if="block.type === 'h2'" :id="anchor(block.text)" :key="`h2-${index}`">{{ block.text }}</h2>
    <h3 v-else-if="block.type === 'h3'" :key="`h3-${index}`">{{ block.text }}</h3>
    <p v-else-if="block.type === 'p'" :key="`p-${index}`" v-html="block.html" />
    <ul v-else-if="block.type === 'ul'" :key="`ul-${index}`">
      <li v-for="(item, itemIndex) in block.items" :key="`ul-${index}-${itemIndex}`" v-html="item" />
    </ul>
    <ol v-else-if="block.type === 'ol'" :key="`ol-${index}`">
      <li v-for="(item, itemIndex) in block.items" :key="`ol-${index}-${itemIndex}`" v-html="item" />
    </ol>
  </template>
</div>
</template>

<script>
export default {
  name: 'DocBlocks',
  props: {
    blocks: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    anchor(text) {
      const value = String(text || '').toLowerCase()
      if (value.includes("won't connect") || value.includes('wont connect')) return 'wont-connect'
      if (value.includes('very slow') || value.includes('is slow')) return 'slow'
      if (value.includes('disconnect')) return 'disconnect'
      if (value.includes('wi-fi') || value.includes('wifi')) return 'wifi'
      if (value.includes('connection failed')) return 'failed'
      return value.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
    },
  },
}
</script>

<style lang="scss" scoped>
.doc-blocks {
  h2 {
    margin: 32px 0 12px;
    font-size: 26px;
    line-height: 1.3;
    color: var(--vpn-ink, #1f2430);
  }

  h3 {
    margin: 22px 0 8px;
    font-size: 18px;
    color: var(--vpn-ink, #1f2430);
  }

  p,
  li {
    color: var(--vpn-ink-muted, #5b6475);
    font-size: 16px;
    line-height: 1.75;
  }

  p {
    margin: 0 0 14px;
  }

  ul,
  ol {
    margin: 0 0 16px;
    padding-left: 22px;
  }

  li + li {
    margin-top: 6px;
  }

  ::v-deep a {
    color: var(--vpn-brand, #1b6fe8);
    font-weight: 600;
  }

  ::v-deep a:hover {
    color: var(--vpn-brand-deep, #1558c0);
  }
}
</style>
